import { combineReducers } from "redux-immutable";

import UserCourseStatsReviewState from "../models/UserCourseStatsReviewState";
import statsReducer, { statsGroupedByDateRangesReducer } from "./state/stats";
import metaReducer from "./state/meta";

export default combineReducers(
  {
    statsGroupedByDateRanges: statsGroupedByDateRangesReducer,
    stats: statsReducer,
    meta: metaReducer
  } as any,
  () => new UserCourseStatsReviewState() as any
);
